import { CancelIlustration } from '@/components/illustrations';

interface CancelMatchCardProps {
	matchId: string;
	title: string;
}

export const CancelMatchCard = ({ matchId, title }: CancelMatchCardProps) => {
	return (
		<div key={matchId} className="my-2 rounded-lg border border-orange-400 bg-violet-25/70 p-5 shadow-xs text-center">
			<div className="flex-col">
				<p className="text-base font-medium text-gray-900">{title}</p>
				<CancelIlustration />
				<p className="pt-2 text-base font-medium text-gray-900">Match Canceled</p>
			</div>
		</div>
	);
};
